import React from "react";
import "./SliderSkeleton.css";

const SliderSkeleton = () => {
  return (
    <div className="slider-skeleton">
      <div className="skeleton-slide"></div>
    </div>
  );
};

export default SliderSkeleton;
